module.exports = __webpack_public_path__ + "static/media/qualitas-pin.599e194c.svg";